import React, { useState } from 'react';
import { Select, Input, Typography, Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import CustomTooltip from '../../components/Components/Modals/CustomTooltip';
import MediumModal from '../../components/Components/Modals/MediumModal';

const { TextArea } = Input;
const { Option } = Select;
const { Text } = Typography;

function TypeOfModellingModal({ isVisible, onSubmit, onCancel, isLoading }) {
    const [typeOfModelling, setTypeOfModelling] = useState('Instaload');
    const [modellingNote, setModellingNote] = useState('');

    // Handle form submission
    const handleSubmit = () => {
        // Se la nota è vuota, usiamo "Empty" per garantire che il campo sia salvato
        const noteToSave = modellingNote.trim() ? modellingNote.trim() : 'Empty';

        // Creiamo un oggetto con i campi espliciti
        const data = {
            type_of_modeling: typeOfModelling,
            modeling_note: noteToSave
        };
        onSubmit(data);
    };

    // Contenuto personalizzato della modale
    const modalContent = (
        <>
            <div style={{ marginBottom: '24px' }}>
                <Space direction="vertical" style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Text strong>Modelling Type</Text>
                        <CustomTooltip title="Select the method used for 3D modelling">
                            <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                        </CustomTooltip>
                    </div>
                    <Select
                        placeholder="Select modelling type"
                        style={{ width: '100%' }}
                        value={typeOfModelling}
                        onChange={value => setTypeOfModelling(value)}
                    >
                        <Option value="Instaload">Instaload</Option>
                        <Option value="Manual">Manual</Option>
                        <Option value="Instaload + Manual">Instaload + Manual</Option>
                    </Select>
                </Space>
            </div>

            <div style={{ marginBottom: '24px' }}>
                <Space direction="vertical" style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Text strong>Modelling Note</Text>
                        <CustomTooltip title="Additional information about the modelling process (optional)">
                            <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                        </CustomTooltip>
                    </div>
                    <TextArea
                        placeholder="Enter notes about the modelling (optional)"
                        rows={4}
                        value={modellingNote}
                        onChange={e => setModellingNote(e.target.value)}
                    />
                </Space>
            </div>
        </>
    );

    return (
        <MediumModal
            title="Modelling Type"
            visible={isVisible}
            onClose={onCancel}
            onConfirm={handleSubmit}
            confirmText="Confirm"
            cancelText="Cancel"
        >
            {modalContent}
        </MediumModal>
    );
}

export default TypeOfModellingModal;